import { Button, ButtonBaseProps, makeStyles, Modal } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ControlContainer from '../components/ControlContainer'
import { OrderContext } from '../OrderContext'
import { CancelButton, PreviousButton } from '../StepperButtons'
import Summary from './Summary'

export const useStyles = makeStyles(theme => ({
    divider: {
        margin: '30px 0'
    },
    totalSpan: {
        float: 'right',
        fontSize: '1.5rem',
        marginTop: '1rem',
    },
    totalP: {
        textAlign: 'right',
        display: 'block',
        size: '1.1rem'
    },
    summary: {
        display: 'grid',
        gridTemplateColumns: 'auto 50px 50px'
    },
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}))

const OrderSummaryNextButton: React.FC<ButtonBaseProps> = (props) => {
    const { activeStep, setActiveStep } = useContext(OrderContext)
    const [display, setDisplay] = useState(false)
    const classes = useStyles()
    const { t } = useTranslation()

    const handleContinue = () => {
        setDisplay(false)
        setActiveStep(activeStep + 1)
    }

    return (
        <>
            <Modal
                open={display}
                onClose={() => setDisplay(false)}
                aria-labelledby='return-modal-title'
                aria-describedby='return-modal-description'
            >
                <div className={classes.paper}>
                    <p>{t('return_policy')}</p>

                    <div style={{ width: '100%', marginTop: 30, display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Button color='secondary' variant='contained' onClick={() => setDisplay(false)}>
                            {t('cancel_return')}
                        </Button>
                        <Button color='primary' variant='contained' onClick={handleContinue}>
                            {t('continue')}
                        </Button>
                    </div>
                </div>
            </Modal>

            <Button
                {...props}
                size='large'
                variant="contained"
                color="primary"
                onClick={() => setDisplay(true)}
            >
                {t("submit")}
            </Button>
        </>
    )
}

const OrderSummary = () => {
    const { loadingSimulate, errorOnSimulate } = useContext(OrderContext)

    return (
        <>
            <Summary />

            <ControlContainer>
                {!(loadingSimulate || errorOnSimulate) && <OrderSummaryNextButton disabled={loadingSimulate} />}
                <PreviousButton />
                <CancelButton />
            </ControlContainer>
        </>
    )
}

export default OrderSummary
